import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.promise.finally.js';
import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useIsMobile, Stack, Button } from '@hub-la/design-system';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../domain/dtos/alert-type.js';
import '../../domain/dtos/error-type.js';
import '../../domain/dtos/main-content-type.js';
import '../../domain/dtos/post-event-type.js';
import { PostStatus } from '../../domain/dtos/post-status.js';
import '../../domain/dtos/query-key.js';
import '../../domain/dtos/remove-dialog-action.js';
import '@hub-la/fe-container';
import '@hub-la/fe-core-http-client';
import 'react-query';
import '../../usecases/save-file.js';
import { useSavePost } from '../hooks/use-save-post.js';

const AdminActions = props => {
  const {
    post,
    productId,
    sectionId,
    onPublish
  } = props;
  const [publishing, setPublishing] = useState(false);
  const savePost = useSavePost();
  const isMobile = useIsMobile();
  const isDraft = (post === null || post === void 0 ? void 0 : post.status) === PostStatus.DRAFT;
  const handlePublish = () => {
    var _a, _b, _c;
    if (!post) return;
    setPublishing(true);
    const attachedIds = (_a = post.attachments) === null || _a === void 0 ? void 0 : _a.map(asset => asset.id);
    const data = {
      status: PostStatus.PUBLISHED,
      title: post.title,
      subtitle: post.subtitle,
      content: (_b = post.content) !== null && _b !== void 0 ? _b : '',
      coverAssetId: (_c = post.cover) === null || _c === void 0 ? void 0 : _c.id,
      attachmentAssetIds: []
    };
    if (attachedIds) {
      data.attachmentAssetIds = attachedIds;
    }
    savePost.mutateAsync({
      payload: post.id ? Object.assign(Object.assign({}, data), {
        id: post.id
      }) : data,
      id: post.id
    }).then(() => {
      onPublish();
    }).finally(() => setPublishing(false));
  };
  return jsxs(Stack, Object.assign({
    spacing: 1,
    marginBottom: [8, 0],
    paddingX: [4, 6],
    direction: "row",
    alignItems: "center"
  }, {
    children: [jsx(Link, Object.assign({
      to: `/hub/create_post/${productId}/${sectionId}?postId=${post.id}`,
      style: {
        width: isMobile ? '100%' : 'auto'
      }
    }, {
      children: jsx(Button, Object.assign({
        fullWidth: isMobile,
        variant: "outlined",
        "data-testid": "edit-button"
      }, {
        children: "Editar"
      }))
    })), jsx(Button, Object.assign({
      fullWidth: isMobile,
      variant: "outlined",
      disabled: !isDraft || publishing,
      onClick: handlePublish,
      "data-testid": "publish-button"
    }, {
      children: isDraft ? 'Publicar' : 'Publicado!'
    }))]
  }));
};

export { AdminActions };
